import {UPDATE_GROUP_CYCLE_START} from "../../types";

export const update_group_cycle = (payload) => ({
    type: UPDATE_GROUP_CYCLE_START,
    payload,
});
